<template>
  <div>
    <div class="main">
      <el-card class="box-card margin-b-20">
        <p class="title">Inicio de sesión</p>
        <el-form
          ref="loginForm"
          :model="model"
          :rules="rules"
          :v-loading="loading"
          @submit.native.prevent="onSubmit">
          <el-form-item
            label="Distribuidor"
            prop="distributor">
            <el-select
              ref="selectDistributor"
              v-model="model.dealerId"
              :remote-method="onSearchDealer"
              :loading="loadingDealers"
              remote
              filterable
              prefix-icon="icon-home"
              class="i-home"
              placeholder="Nombre del distribuidor"
              @change="loadBranches">
              <el-option
                v-for="item in dealers"
                :key="item.id"
                :label="item.dealer"
                :value="item.id"/>
            </el-select>
          </el-form-item>

          <el-form-item
            label="Ship to"
            prop="ship">
            <el-select
              v-model="model.shipTo"
              :loading="loadingBranches"
              prefix-icon="icon-truck"
              class="i-truck"
              placeholder="Sucursal">
              <el-option
                v-for="item in branches"
                :key="item.shipTo"
                :label="item.shipTo"
                :value="item.shipTo"
              >
                {{ item.shipTo }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="Vendedor"
            prop="name">
            <el-input
              v-model="model.name"
              placeholder="Escribe tu nombre completo"
              class="no-icon"/>
          </el-form-item>
          <el-button
            :disabled="loading"
            :loading="loading"
            type="primary"
            native-type="submit">Ingresar
          </el-button>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import LoginModel from '@/models/login.model'
import http from '@/services/http.service'
import auth from '@/services/auth.service'

export default {
  name: 'LoginForm',
  data () {
    return {
      dealerSearch: '',
      loading: false,
      loadingDealers: false,
      loadingBranches: false,
      submitting: false,
      model: LoginModel.model(),
      rules: LoginModel.rules(),
      dealers: [],
      branches: []
    }
  },
  mounted () {
    this.$refs.selectDistributor.focus()
  },
  methods: {
    onSearchDealer (search) {
      this.loadingDealers = true
      http.get('dealers', {
        params: {
          'filters[where][dealer][contains]': search,
          'sort': 'dealer ASC'
        }
      }).then(response => {
        this.dealers = response.data.items
        this.model.shipTo = null
        this.loadingDealers = false
      }).catch((e) => {
        console.log(e)
        this.loadingDealers = false
      })
    },
    loadBranches () {
      console.log('delaers', this.dealers)
      let currentDealer = this.dealers.find(dealer => {
        return dealer.id === this.model.dealerId
      })
      this.model.billTo = currentDealer.billTo
      this.model.shipTo = null
      this.branches = []
      this.loadingBranches = true
      http.get('branches', {
        params: {
          'filters[where][dealerId][eq]': this.model.dealerId
        }
      }).then(response => {
        this.branches = response.data.items
        this.loadingBranches = false
      })
    },
    onSubmit () {
      this.loading = true
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('setLogin', this.model)
          auth.authenticate(this.model.billTo, this.model.shipTo, this.model.name)
            .then(() => {
              this.$router.push({name: 'invoice'})
            })
            .catch(e => {
              console.log(e)
              this.loading = false
            })
        } else {
          this.$message.error('Por favor, corrija los errores en la forma')
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown__item{
  color:#333;
}
</style>



// WEBPACK FOOTER //
// src/components/login-form.vue